import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-job-signoff-shredder',
    templateUrl: './job-signoff-shredder.component.html',
    styleUrls: ['./job-signoff-shredder.component.scss'],
    standalone: false
})
export class JobSignoffShredderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
